import { FlowOcrBoundingBoxMode, FlowOcrDetailLevel, FlowOcrMethod } from 'flow-schema';
import { z } from 'zod';

import {
  type BaseFlowBlock,
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

// @deprecated
export interface OcrBlock extends BaseFlowBlock {
  type: BlockType.Ocr;
  config: {
    gsPaths: {
      gsPath: string;
    }[];
  };
}

export const RECOMMENDED_OCR_METHOD = FlowOcrMethod.VisionLanguageModel;

export const OcrV2BlockConfigSchema = z.object({
  fileReference: z.string().min(1),
  detailLevel: z.enum(FlowOcrDetailLevel).default(FlowOcrDetailLevel.None),
  boundingBoxMode: z.enum(FlowOcrBoundingBoxMode).default(FlowOcrBoundingBoxMode.None),
  method: z.enum(FlowOcrMethod).default(RECOMMENDED_OCR_METHOD),
  prompt: z.string().optional(),
});
export type OcrV2BlockConfig = z.infer<typeof OcrV2BlockConfigSchema>;

export const OcrV2BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.OcrV2),
  config: OcrV2BlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.OcrDetailResponse),
});
export type OcrV2Block = z.infer<typeof OcrV2BlockSchema>;
